import Icon from '../components/Icon.vue'

Icon.register({
  angry: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM136 240c0 17.7 14.4 32 32.1 32 17.7 0 32-14.3 32-32 0-2.9-1-5.5-1.7-8.2 0.6 0 1.2 0.2 1.7 0.2 6.9 0 13.2-4.5 15.3-11.4 2.6-8.4-2.2-17.4-10.7-19.9l-80-24c-8.5-2.5-17.4 2.2-19.9 10.7-2.6 8.4 2.2 17.4 10.7 19.9l31 9.3c-6.4 5.9-10.5 14.1-10.5 23.4zM304 394.2c13.4 16.1 38.3-4 24.5-20.5-20-24-49.4-37.8-80.6-37.8-31.2 0-60.6 13.8-80.6 37.8-13.6 16.3 11.1 36.8 24.6 20.5 27.9-33.4 84.3-33.4 112.1 0zM380.6 207.3c8.5-2.5 13.3-11.4 10.8-19.9-2.5-8.4-11.5-13.2-19.9-10.7l-80 24c-8.4 2.5-13.2 11.4-10.7 19.9 2.1 6.9 8.4 11.4 15.3 11.4 0.6 0 1.1-0.1 1.7-0.2-0.8 2.6-1.7 5.3-1.7 8.2 0 17.7 14.3 32 32 32 17.7 0 32-14.3 32-32 0-9.3-4.2-17.6-10.5-23.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/angry.js
// module id = 610
// module chunks = 0